import { API_CONFIG } from "../../utils/apiConfig";

function BrandLogo({ size = "md", compact = false, className = "" }) {
  const sizes = {
    xs: compact ? "h-7 w-7" : "h-7 w-auto max-w-[130px]",
    sm: compact ? "h-8 w-8" : "h-9 w-auto max-w-[170px]",
    md: compact ? "h-10 w-10" : "h-10 w-auto max-w-[210px]",
    lg: compact ? "h-12 w-12" : "h-14 w-auto max-w-[260px]",
    xl: compact ? "h-16 w-16" : "h-18 w-auto max-w-[340px]",
  };

  const imageClass = `${sizes[size] || sizes.md} object-contain`;

  if (API_CONFIG.isDemo) {
    const iconOnlySizes = {
      xs: "h-6 w-6",
      sm: "h-7 w-7",
      md: "h-9 w-9",
      lg: "h-12 w-12",
      xl: "h-16 w-16",
    };

    if (compact) {
      return (
        <div className={`flex items-center justify-center ${className}`.trim()}>
          <img
            src="/logo/demo/anaxis-icon.png"
            alt="ANAXISTECH"
            className={`${iconOnlySizes[size] || iconOnlySizes.md} object-contain shrink-0`}
          />
        </div>
      );
    }

    const lockupConfig = {
      xs: {
        icon: "h-6 w-6",
        title: "text-[14px]",
        tagline: "text-[6px]",
        gap: "gap-2",
      },
      sm: {
        icon: "h-7 w-7",
        title: "text-[16px]",
        tagline: "text-[7px]",
        gap: "gap-2",
      },
      md: {
        icon: "h-8 w-8",
        title: "text-[18px]",
        tagline: "text-[7.5px]",
        gap: "gap-2.5",
      },
      lg: {
        icon: "h-10 w-10",
        title: "text-[22px]",
        tagline: "text-[9px]",
        gap: "gap-3",
      },
      xl: {
        icon: "h-14 w-14",
        title: "text-[28px]",
        tagline: "text-[11px]",
        gap: "gap-3.5",
      },
    };

    const cfg = lockupConfig[size] || lockupConfig.md;

    return (
      <div className={`flex items-center ${cfg.gap} select-none ${className}`.trim()}>
        <img
          src="/logo/demo/anaxis-icon.png"
          alt="ANAXISTECH"
          className={`${cfg.icon} object-contain shrink-0`}
        />
        <div className="flex flex-col justify-center">
          <div className={`font-black tracking-wide leading-none ${cfg.title}`}>
            <span className="text-[#0a3866] dark:text-white">ANAXIS</span>
            <span className="text-[#008cd6] dark:text-[#38bdf8]">TECH</span>
          </div>
          <span className={`font-semibold tracking-[0.16em] text-[#4a6b8c] dark:text-slate-400 uppercase leading-none mt-1 ${cfg.tagline}`}>
            Innovating your imagination
          </span>
        </div>
      </div>
    );
  }

  if (compact) {
    return (
      <div className={`flex items-center ${className}`.trim()}>
        <img src="/logo/svg/logo-03.svg" alt="Ferrovan Global LLP" className={imageClass} />
      </div>
    );
  }

  return (
    <div className={`flex items-center ${className}`.trim()}>
      <img src="/logo/svg/logo-02.svg" alt="Ferrovan Global LLP" className={`${imageClass} dark:hidden`} />
      <img src="/logo/svg/logo-02.svg" alt="Ferrovan Global LLP" className={`${imageClass} hidden dark:block`} />
    </div>
  );
}

export default BrandLogo;
